import Dialog from '../../../../../components/dialog/Dialog'
import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import links from '../../../../../enums/linksEnum'
import { useHistory } from 'react-router-dom'
import portals from '../../../../../enums/portalsEnum'
import CloseIcon from '@material-ui/icons/Close'
import Button from '../../../../../components/button/Button'
import { useRouteMatch } from 'react-router'
import { MatchParamsModel, PaymentResultModel } from '../account_model'
import fetchFactory from '../../../../../utils/fetchFactory'
import Loader from '../../../../../components/loader/Loader'
import { saveInteractions } from '../../../../gtm/utils/gtmCallback'


const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            headerStyleLargeScreen: {
                '& #logo': {
                    cursor: 'pointer',
                    margin: '2vw',
                    width: '100%',
                    maxWidth: 150
                }
            },
            headerStyleSmallScreen: {
                width: '100%',
                margin: 0,
                height: '10vw',
                minHeight: 50,

                '& > div:first-child': {
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',

                    '& #logo': {
                        height: '100%',
                        marginRight: 15
                    }
                }
            },
            iconStyle: {
                background: theme.palette.blue['5'],
                padding: 12,
                borderRadius: '100%',
                color: theme.palette.blue.main,
                cursor: 'pointer'
            },
            childContainerLargeScreenStyle: {
                width: '60%',
                maxWidth: 900,
                margin: '25px auto 0'
            },
            childContainerSmallScreenStyle: {
                marginTop: 40
            },
            subHeaderStyle: {
                width: '80%',
                maxWidth: 1100,
                margin: '54px auto 0',
                '& p': {
                    color: theme.palette.blue.main,
                    margin: 0
                }
            },
            buttonsContainerStyle: {
                justifyContent: 'center',
                '& div:first-child': {
                    marginBottom: 15
                }
            }
        }
    )
)

const SUCCESS_STATUS = 'success'
const SPECIFIC_ERROR_CODE = '001'

const PaymentFinishedPage: React.FC = () => {
    const classes = useStyle()
    const history = useHistory()
    const match = useRouteMatch<MatchParamsModel>()
    const [paymentStatus, setPaymentStatus] = useState<PaymentResultModel | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(true)

    const isLargeScreen = useMediaQuery(
        {
            query: '(min-width: 1025px)'
        }
    )

    const headerClass: ClassValue = classNames(
        'row middle-xs',
        classes.flexBetween,
        isLargeScreen ? classes.headerStyleLargeScreen : classes.headerStyleSmallScreen
    )

    const childContainerClass: ClassValue = classNames(
        {
            [classes.childContainerLargeScreenStyle]: isLargeScreen,
            [classes.childContainerSmallScreenStyle]: !isLargeScreen
        }
    )

    const titleSmallScreenClass: ClassValue = classNames(
        classes.title5,
        classes.colorBlue
    )

    const subHeaderClass: ClassValue = classNames(
        'row middle-xs',
        classes.subHeaderStyle
    )

    const textClass: ClassValue = classNames(
        classes.colorBlue,
        classes.text13_opacity
    )

    const buttonsContainerClass: ClassValue = classNames(
        'row',
        {
            [classes.buttonsContainerStyle]: !isLargeScreen
        }
    )

    useEffect(() => {
        const id = match.params.id
        fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/payment/check-payment/${id}`, { method: 'POST' })
            .then((res: any) => {
                if (res.status === SUCCESS_STATUS) {
                    saveInteractions(
                        {
                            category: 'Votre Compte',
                            action: 'Paiement en ligne',
                            label: 'Règlement::OK'
                        }
                    )
                }

                setPaymentStatus({ ...res, isSuccess: res.status === SUCCESS_STATUS })
            })
            .finally(() => setLoading(false))
    }, [match])

    const closeDialog = () => {
        history.push(links.contracts)
    }

    const handleCode = (code: string = '') => {
        if (code.startsWith(SPECIFIC_ERROR_CODE)) {
            return SPECIFIC_ERROR_CODE
        }
        return code
    }

    const redirectTo = (link: string) => {
        history.push(link)
    }

    const stepWordingTitle = paymentStatus?.isSuccess ? 'success' : 'error'

    return <Dialog
        onCloseDialog={closeDialog}
        open
    >
        <>
            {loading ?
                <Loader />
                :
                <>
                    <div className={headerClass}>
                        {
                            isLargeScreen ? (
                                <div className="col-md-2">
                                    <img
                                        src={process.env.REACT_APP_TARGET === portals.residence ? 'img/youFirst.jpg' : 'img/youFirstCampus.svg'}
                                        alt="Logo Youfirst"
                                        id="logo"
                                        onClick={() => redirectTo(links.dashboard)}
                                    />
                                </div>
                            ) : (
                                <div className="col-xs-8">
                                    {
                                        <span className={titleSmallScreenClass}>
                                    <FormattedMessage
                                        id={`contracts.account.payment.finished.${stepWordingTitle}.title`}
                                        defaultMessage="Paiement finalisé"
                                        description="Modal title"
                                    />
                                </span>
                                    }

                                </div>
                            )
                        }
                        <div className="col-xs-4 col-md-2">
                            <div className="row middle-xs end-xs">
                                <div className="col-xs-12 col-md-4">
                                    <CloseIcon
                                        onClick={closeDialog}
                                        className={classes.iconStyle}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {isLargeScreen && <div className={subHeaderClass}>
						<div className="col-xs-offset-1 col-xs-11">
							<p className={classes.title2}>
								<FormattedMessage
									id={`contracts.account.payment.finished.${stepWordingTitle}.title`}
									defaultMessage="Paiement finalisé"
									description="Modal title"
								/>
							</p>
						</div>
					</div>}
                    <div className={childContainerClass}>
                        <p className={textClass}>
                            {paymentStatus?.isSuccess ?
                                <FormattedMessage
                                    id="contracts.account.payment.finished.success.description"
                                    defaultMessage="Paiement finalisé"
                                    description="Paiement description"
                                    values={{
                                        strong: (msg: string) => <strong>{msg}</strong>,
                                        p: (msg: string) => <p>{msg}</p>
                                    }}
                                />
                                :
                                <FormattedMessage
                                    id={`contracts.account.payment.finished.error.description.${handleCode(paymentStatus?.code)}`}
                                    defaultMessage="Paiement en erreur"
                                    description="Paiement description"
                                />
                            }
                        </p>
                        <img
                            src="img/contracts/requestSummary/sendImg.png"
                            alt="Send icon"
                            width="350"
                        />
                        <div className={buttonsContainerClass}>
                            <div className="col-xs-10 col-md-offset-10 col-md-2">
                                <Button
                                    background="backgroundAccessibility"
                                    color="colorWhite"
                                    textStyle="text8"
                                    size="bigButton"
                                    onClick={closeDialog}
                                >
                                    <FormattedMessage
                                        id="global.btn.finish"
                                        defaultMessage="Terminer"
                                        description="Summary button"
                                    />
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    </Dialog>
}

export default PaymentFinishedPage